import React from 'react';
import './LogoSlider.css';

const LogoSlider = () => {
  const logos = [
    { name: 'Personify Health', src: '/logos/personifyhealth.png' },
    { name: 'Workhuman', src: '/logos/workhuman.png' },
    { name: 'Logic Broker', src: '/logos/logicbroker.png' },
    { name: 'Asurion', src: '/logos/asurion.jpg' },
    { name: 'ChargeAfter', src: '/logos/chargeafter.png' },
    { name: 'Credit Key', src: '/logos/creditkey.png' },
    { name: 'Samsung', src: '/logos/samsung.png' },
  ];

  // Duplicate logos for seamless infinite scroll
  const duplicatedLogos = [...logos, ...logos, ...logos];

  return (
    <div className="logo-slider-container">
      <div className="logo-slider-track">
        {duplicatedLogos.map((logo, index) => (
          <div key={index} className="logo-slide">
            <img
              src={logo.src}
              alt={logo.name}
              className="logo-image"
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default LogoSlider;
